(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('footer-mobile-accordions')) {
    customElements.define('footer-mobile-accordions', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.rows = Array.from(this.querySelectorAll('.footer-menu-block-mobile-element')).map(details => {
          const summary = details.querySelector('summary');
          const panel = summary.nextElementSibling;
          const row = { details, summary, panel, expanded: details.open, animation: null };
          summary.setAttribute('aria-expanded', String(row.expanded));
          details.dataset.expanded = String(row.expanded);
          panel.inert = !row.expanded;
          summary.addEventListener('click', event => {
            event.preventDefault();
            const expanded = !row.expanded;
            if (expanded) this.rows.forEach(other => {
              if (other !== row && other.expanded) this.setExpanded(other, false);
            });
            this.setExpanded(row, expanded);
          }, { signal: this.abortController.signal });
          details.addEventListener('keydown', event => {
            if (event.key === 'Escape' && row.expanded) {
              event.preventDefault();
              this.setExpanded(row, false);
              summary.focus();
            }
          }, { signal: this.abortController.signal });
          return row;
        });
      }

      setExpanded(row, expanded) {
        const startHeight = row.details.open ? row.panel.getBoundingClientRect().height : 0;
        if (row.animation) row.animation.cancel();
        row.animation = null;
        row.expanded = expanded;
        row.details.dataset.expanded = String(expanded);
        row.summary.setAttribute('aria-expanded', String(expanded));
        if (!expanded && row.panel.contains(document.activeElement)) row.summary.focus();
        row.panel.inert = !expanded;
        row.details.open = true;
        row.panel.style.height = '';
        const endHeight = expanded ? row.panel.scrollHeight : 0;
        const finish = () => {
          row.details.open = expanded;
          row.panel.style.height = '';
          row.panel.style.overflow = '';
          row.animation = null;
        };
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !row.panel.animate) {
          finish();
          return;
        }
        row.panel.style.overflow = 'hidden';
        row.animation = row.panel.animate(
          [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
          { duration: 500, easing: 'cubic-bezier(0.4, 0, 1, 1)' }
        );
        row.animation.onfinish = finish;
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.rows?.forEach(row => {
          row.animation?.cancel();
          row.details.open = row.expanded;
          row.panel.style.height = '';
          row.panel.style.overflow = '';
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.enableScroll();
    }

    disconnectedCallback() {
      this.disableScroll();
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
